module.exports = __webpack_public_path__ + "img/KitkitShuleLibrary.e52a8181.png";